import { AlertFilled, ExperimentFilled, FlagOutlined, TagsOutlined } from '@ant-design/icons'
import { SectorMultiSelect } from '@components/_SiteWide/HeaderControls'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { getMarketSectors, sortNumeric } from '@utils/general'
import { Radio, Select, Skeleton, Tooltip } from 'antd'
import React from 'react'

import { useSecurityContext } from '../../Navigation/SecurityContext'
import { useSiteMonitoringContext } from '../SiteMonitoringContext'

const { Option } = Select

const options = [
  { label: 'All', value: 'none' },
  { label: 'Yes', value: 'has_order' },
  { label: 'No', value: 'no_order' },
]
const matchOnOptions = [
  { label: 'Sites', value: 'stores' },
  { label: 'Tanks', value: 'tanks' },
]
const managedByOptions = [
  { label: 'All', value: 'all' },
  { label: 'Internal', value: 'internal' },
  { label: 'Managed', value: 'managed' },
]

export function Filters({ isMobile }) {
  const { setFilters, filterOptions, filters } = useSiteMonitoringContext()

  const { scopes } = useSecurityContext()

  const handleHasOrderChange = (e) => {
    setFilters({
      ...filters,
      has_order: e.target.value,
    })
  }
  const onCarrierTypeChange = (e) => {
    setFilters((oldFilters) => ({
      ...oldFilters,
      view: e.target.value,
      carriers: e.target.value !== 'carriers' ? [] : oldFilters.carriers,
    }))
  }
  const handleMatchOnChange = (e) => {
    setFilters({
      ...filters,
      match_only_tank: e.target.value === 'tanks',
    })
  }

  if (!filterOptions)
    return (
      <div className='p-4 bg-2 vertical-flex' style={{ flex: '0 0 350px' }}>
        <Skeleton active rows={16} />
        <Skeleton active rows={16} />
        <Skeleton active rows={16} />
      </div>
    )

  function getMobileFilters() {
    return (
      <Vertical gap='8px' className={isMobile ? 'p-4' : ''}>
        <SectorMultiSelect
          style={{ width: '100%', maxWidth: '100%' }}
          sectors={filterOptions.sectors}
          handleSectorChange={(sectors) => {
            if (sectors.length === 1 && filterOptions.sectors.some((s) => s.name === sectors[0])) {
              setFilters({
                ...filters,
                sectors: undefined,
                market: sectors[0],
              })
            } else {
              const sectorValues = getMarketSectors(sectors, filterOptions.sectors)
              setFilters({ ...filters, sectors: sectorValues, market: '' })
            }
          }}
          selectedValues={getMarketSectors(
            filters?.market ? [filters?.market] : filters?.sectors,
            filterOptions.sectors
          )}
          byMarket
        />
        <StoreMonitorSelect
          tooltip='Select Products to filter'
          placeHolders={
            <>
              <ExperimentFilled className='filter-icon' />
              Products
            </>
          }
          onChange={(products) => {
            setFilters({ ...filters, products })
          }}
          items={filterOptions.products && sortNumeric(filterOptions.products)}
          value={filters?.products}
        />
        <StoreMonitorSelect
          tooltip='Alerts'
          placeHolders={
            <>
              <AlertFilled className='filter-icon' />
              Alerts
            </>
          }
          onChange={(alerts) => {
            setFilters({ ...filters, alerts })
          }}
          items={filterOptions.alerts}
          value={filters?.alerts}
        />
        <StoreMonitorSelect
          tooltip='Tags'
          placeHolders={
            <>
              <TagsOutlined className='filter-icon' />
              Tags
            </>
          }
          onChange={(tank_tags) => {
            setFilters({ ...filters, tank_tags })
          }}
          value={filters?.tank_tags}
          items={filterOptions.tank_tags}
        />{' '}
        {filters?.view !== 'internal' && (
          <CarrierSelect setFilters={setFilters} filters={filters} filterOptions={filterOptions} />
        )}
        {!scopes.is_carrier && (
          <ManagedBy
            isMobile
            setFilters={setFilters}
            filters={filters}
            filterOptions={filterOptions}
            managedByOptions={managedByOptions}
            onCarrierTypeChange={onCarrierTypeChange}
          />
        )}
        <MatchOn handleMatchOnChange={handleMatchOnChange} filters={filters} matchOnOptions={matchOnOptions} />
        <HasOrder handleHasOrderChange={handleHasOrderChange} filters={filters} options={options} />
      </Vertical>
    )
  }

  function getDesktopFilters() {
    return (
      <div className='p-4 bg-3 bordered'>
        <Horizontal>
          <div className=' mr-3 vertical-flex-center flex-1'>
            <SectorMultiSelect
              style={{ width: '100%', maxWidth: '100%' }}
              sectors={filterOptions.sectors}
              handleSectorChange={(sectors) => {
                if (sectors.length === 1 && filterOptions.sectors.some((s) => s.name === sectors[0])) {
                  setFilters({
                    ...filters,
                    sectors: undefined,
                    market: sectors[0],
                  })
                } else {
                  const sectorValues = getMarketSectors(sectors, filterOptions.sectors)
                  setFilters({ ...filters, sectors: sectorValues, market: '' })
                }
              }}
              selectedValues={getMarketSectors(
                filters?.market ? [filters?.market] : filters?.sectors,
                filterOptions.sectors
              )}
              byMarket
            />
          </div>
          <div className=' vertical-flex-center flex-1 mr-3'>
            <StoreMonitorSelect
              tooltip='Select Products to filter'
              placeHolders={
                <>
                  <ExperimentFilled className='filter-icon' />
                  Products
                </>
              }
              onChange={(products) => {
                setFilters({ ...filters, products })
              }}
              items={filterOptions.products && sortNumeric(filterOptions.products)}
              value={filters?.products}
            />
          </div>

          {!scopes.is_carrier && (
            <>
              <div className='flex items-center flex-1 mr-3' style={{ justifyContent: 'right' }}>
                <ManagedBy
                  setFilters={setFilters}
                  filters={filters}
                  filterOptions={filterOptions}
                  managedByOptions={managedByOptions}
                  onCarrierTypeChange={onCarrierTypeChange}
                />
              </div>

              {filters?.view !== 'internal' && (
                <div className='vertical-flex-center flex-1 mr-3'>
                  <CarrierSelect setFilters={setFilters} filters={filters} filterOptions={filterOptions} />
                </div>
              )}
            </>
          )}
        </Horizontal>
        <Horizontal gap={16} className='mt-4'>
          <div className='vertical-flex-center flex-1'>
            <StoreMonitorSelect
              tooltip='Alerts'
              placeHolders={
                <>
                  <AlertFilled className='filter-icon' />
                  Alerts
                </>
              }
              onChange={(alerts) => {
                setFilters({ ...filters, alerts })
              }}
              items={filterOptions.alerts}
              value={filters?.alerts}
            />
          </div>
          <Horizontal className='mr-3' gap={16}>
            <MatchOn handleMatchOnChange={handleMatchOnChange} filters={filters} matchOnOptions={matchOnOptions} />
            <HasOrder handleHasOrderChange={handleHasOrderChange} filters={filters} options={options} />
          </Horizontal>

          <div className='vertical-flex-center flex-1 mr-3 '>
            <StoreMonitorSelect
              tooltip='Tags'
              placeHolders={
                <>
                  <TagsOutlined className='filter-icon' />
                  Tags
                </>
              }
              onChange={(tank_tags) => {
                setFilters({ ...filters, tank_tags })
              }}
              value={filters?.tank_tags}
              items={filterOptions.tank_tags}
            />
          </div>
        </Horizontal>
      </div>
    )
  }

  return isMobile ? getMobileFilters() : getDesktopFilters()
}

export function StoreMonitorSelect({ tooltip, placeHolders, onChange, items = [], value, width = '100%' }) {
  return (
    <Tooltip placement='topLeft' mouseEnterDelay={2} title={tooltip}>
      <Select
        value={value}
        mode='multiple'
        allowClear
        style={{ width, maxWidth: '100%' }}
        placeholder={placeHolders}
        onChange={onChange}
        listHeight={100}
      >
        {items.map((name) => (
          <Option key={name}>{name}</Option>
        ))}
      </Select>
    </Tooltip>
  )
}

export function CarrierSelect({ setFilters, filters, filterOptions }) {
  return (
    <StoreMonitorSelect
      tooltip='Carriers'
      placeHolders={
        <>
          <FlagOutlined className='filter-icon' />
          Carriers
        </>
      }
      onChange={(carriers) => {
        setFilters({ ...filters, carriers })
      }}
      items={filterOptions.carriers}
      value={filters?.carriers}
    />
  )
}

export function ManagedBy({ setFilters, filters, filterOptions, onCarrierTypeChange, managedByOptions, isMobile }) {
  return (
    <div className={`flex items-center justify-sb`}>
      <Texto className='mr-3' category='label' weight='bold'>
        Managed By
      </Texto>
      <Radio.Group
        onChange={onCarrierTypeChange}
        optionType='button'
        options={managedByOptions}
        value={filters?.view || 'all'}
      />
    </div>
  )
}

function MatchOn({ handleMatchOnChange, filters, matchOnOptions }) {
  return (
    <div className={`flex items-center justify-sb`}>
      <Texto className='mr-3' category='label' weight='bold'>
        Match On
      </Texto>
      <Radio.Group
        onChange={handleMatchOnChange}
        optionType='button'
        options={matchOnOptions}
        value={filters?.match_only_tank ? 'tanks' : 'stores'}
      />
    </div>
  )
}

function HasOrder({ handleHasOrderChange, filters, options }) {
  return (
    <div className={`flex items-center justify-sb`}>
      <Texto className='mr-3' category='label' weight='bold'>
        Has Order
      </Texto>
      <div className='items-center'>
        <Radio.Group
          onChange={handleHasOrderChange}
          optionType='button'
          options={options}
          value={filters?.has_order || 'none'}
        />
      </div>
    </div>
  )
}
